import React from 'react';
import PropTypes from 'prop-types';
import styles from './SearchAndCart.module.sass';
import Cart from '../../../../cart/components/cart/Cart';
import Search from '../../search/Search';

function SearchAndCart(props) {
  const {
    defaultLineItemsCount, freeSamplesTitle, blackBackground, sticky,
  } = props;
  return (
    <div className={styles['search-and-cart']}>
      <Search blackBackground={blackBackground} sticky={sticky} />
      <Cart
        defaultLineItemsCount={defaultLineItemsCount}
        freeSamplesTitle={freeSamplesTitle}
        blackBackground={blackBackground}
        sticky={sticky}
      />
    </div>
  );
}

SearchAndCart.propTypes = {
  defaultLineItemsCount: PropTypes.number,
  freeSamplesTitle: PropTypes.string.isRequired,
  blackBackground: PropTypes.bool.isRequired,
  sticky: PropTypes.bool.isRequired,
};

export default SearchAndCart;
